const CaptureView = async () => import('@/views/effort/CaptureView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    meta: { title: 'TimeTracking in Leistung konvertieren' },
    path: '/time-tracking/convert/:id',
    name: 'timetracking_convert_to_effort',
    component: CaptureView,
    props: (route) => {
      return { timetrackingSource: Number(route.params.id) }
    }
  }
]
